// src/components/ProtectedRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children, requireAdmin = false, requireMerchandiser = false, requireSuperAdmin = false }) => {
  const { isAuthenticated, isAdmin, loading, isMerchandiser, isSuperAdmin } = useAuth();

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundColor: '#f5f5f5'
      }}>
        <div style={{
          fontSize: '18px',
          color: '#2d5016',
          fontWeight: '500'
        }}>Loading...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (requireAdmin && !isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  if (requireMerchandiser && !isMerchandiser) {
    return <Navigate to="/dashboard" replace />;
  }

  if (isMerchandiser) {
    const allowed = ['/stock-dashboard'];

    if (!allowed.includes(window.location.pathname)) {
      return <Navigate to="/stock-dashboard" replace />;
    }
  }

  if(requireSuperAdmin && !isSuperAdmin){
    return <Navigate to="/dashboard" replace />;
  }

  if(isSuperAdmin){
    const allowed = ['/company-admin'];

    if(!allowed.includes(window.location.pathname)) {
      return <Navigate to="/company-admin" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;